import { HFlow, Icon, SelectHelperMenuItem, Text } from 'bold-ui'
import { AsyncQuerySelectField, AsyncSelectQueryFieldProps } from 'components/form/field'
import { Cpf } from 'components/label'
import { ButtonLink } from 'components/route'
import { ProfissionalSelectDocument } from 'graphql/hooks.generated'
import { ProfissionalSelectQuery, ProfissionalSelectQueryVariables } from 'graphql/types.generated'
import React from 'react'
import { useRouteMatch } from 'react-router'

import { DEFAULT_SELECT_SIZE } from '../AsyncQuerySelectField'

export type ProfissionalSelectModel = ProfissionalSelectQuery['profissionais']['content'][0]

export interface ProfissionalSelectFieldProps
  extends AsyncSelectQueryFieldProps<
    ProfissionalSelectModel,
    ProfissionalSelectQuery,
    ProfissionalSelectQueryVariables
  > {
  mostrarSemLotacaoAtiva?: boolean
}

export function ProfissionalSelectField(props: ProfissionalSelectFieldProps) {
  const { mostrarSemLotacaoAtiva } = props

  const { url } = useRouteMatch()

  const variables = (inputQuery: string): ProfissionalSelectQueryVariables => ({
    input: {
      query: inputQuery,
      mostrarSemLotacaoAtiva: mostrarSemLotacaoAtiva,
      pageParams: {
        size: DEFAULT_SELECT_SIZE,
        sort: ['nome'],
      },
    },
  })

  const extractItems = (data: ProfissionalSelectQuery) => data && data.profissionais && data.profissionais.content

  const itemToString = (item: ProfissionalSelectModel) => item && item.nome

  const renderItem = (item: ProfissionalSelectModel) => {
    return (
      <>
        <Text component='p' fontWeight='bold'>
          {item.nome}
        </Text>
        <HFlow hSpacing={0.25}>
          <Text fontWeight='bold'>CPF</Text>
          <Cpf value={item.cpf} />
        </HFlow>
      </>
    )
  }

  const AppendItem = () => (
    <SelectHelperMenuItem style={{ listStyle: 'none' }}>
      <HFlow alignItems='center'>
        <Text>Cadastre um profissional se não o encontrar na busca.</Text>
        <ButtonLink to={`/profissional/create?callbackLink=${url}`} kind='primary' size='small'>
          <Icon icon='plus' style={{ marginRight: '0.25rem' }} />
          Cadastrar profissional
        </ButtonLink>
      </HFlow>
    </SelectHelperMenuItem>
  )

  return (
    <AsyncQuerySelectField<ProfissionalSelectModel, ProfissionalSelectQuery, ProfissionalSelectQueryVariables>
      query={ProfissionalSelectDocument}
      variables={variables}
      extractItems={extractItems}
      itemToString={itemToString}
      renderItem={renderItem}
      components={{ AppendItem }}
      menuMinWidth={496}
      {...props}
    />
  )
}
